import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Modal, Box, Grid, Card, CardContent, Typography, CardActionArea } from '@mui/material'
import { clearReduxFormState } from 'utils/helpers'

const HotkeyModal = ({ isOpen, onClose, options }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleOptionSelect = action => {
    clearReduxFormState(dispatch)
    navigate(action)
  }

  useEffect(() => {
    const handleKeyPress = event => {
      if (!isOpen) return

      // Handle number keys 1-9
      const num = parseInt(event.key)
      if (num >= 1 && num <= options.length) {
        handleOptionSelect(options[num - 1].action)
      }
    }

    window.addEventListener('keydown', handleKeyPress)
    return () => window.removeEventListener('keydown', handleKeyPress)
  }, [isOpen, options])

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          maxWidth: '600px',
          backgroundColor: 'background.color',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          backdropFilter: 'blur(16px)',
          outline: 'none',
        }}
      >
        <Typography variant="h6" mb={2}>
          Click or use your keyboard to select an option
        </Typography>
        <Grid container spacing={2}>
          {options.map((option, index) => (
            <Grid item xs={12} sm={6} key={option.title}>
              <Card sx={{ borderRadius: 2 }}>
                <CardActionArea onClick={() => handleOptionSelect(option.action)}>
                  <CardContent sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="h5">{option.title}</Typography>
                    <Typography variant="h5" color="textSecondary">
                      {index + 1}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Modal>
  )
}

HotkeyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      action: PropTypes.string.isRequired,
      module: PropTypes.string.isRequired,
    }),
  ).isRequired,
}

export default HotkeyModal
